import { Component, OnInit, Compiler } from '@angular/core';
import { AuthLoginService } from '../../services/auth-login.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomValidatorService } from 'src/app/shared/services/custom-validator.service';
import { Title } from '@angular/platform-browser';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserModuleConsts } from '../../constants';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { environment } from 'src/environments/environment';
import { SharedConsts } from 'src/app/shared/constants';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { loadConfigData } from 'src/app/shared/store/actions/shared.actions';
import { Store } from '@ngrx/store';
import { SharedState } from 'src/app/shared/store/reducers';

var CryptoJS = require('crypto-js');

declare const branch: any;

@Component({
  selector: 'sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  standalone: false,
})
export class SignInComponent implements OnInit {
  fieldTextType: boolean;
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  loginForm: FormGroup;
  submitted = false;
  errMessage: any;
  hide: boolean = false;
  is_redirected_user = false;
  heading_message = UserModuleConsts.default_redirection_heading;
  paragraph_message = UserModuleConsts.default_redirection_message;
  is_signed_differen_user = false;
  has_cancelled = false;
  current_year = new Date().getFullYear();

  constructor(
    private loginAuthService: AuthLoginService,
    private statePersistService: StatePersistService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private _compiler: Compiler,
    private customValidator: CustomValidatorService,
    private titleService: Title,
    private authService: AuthService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private store: Store<SharedState>
  ) {
    const is_logged_in = this.checkIfLoggedIn();

    if (is_logged_in && !this.route.queryParams['_value']._branch_match_id) {
      this.router.navigate(['home']);
    } else {
      this.checkRedirectedData(is_logged_in);
    }
  }

  checkRedirectedData(isUserLoggedIn: boolean) {
    branch.init(environment.branch_io_secret, (err: any, data: any) => {
      if (err) {
        console.error('Branch init error:', err);
        return;
      }
      if (data?.data_parsed) {
        const ciphertext = decodeURIComponent(data.data_parsed.data);
        const decrypted_bytes = CryptoJS.TripleDES.decrypt(ciphertext, environment.wos_secret_key);
      try {
        const decryptedText = decrypted_bytes.toString(CryptoJS.enc.Utf8);
        const decryptedData = JSON.parse(decryptedText);
        this.checkRedirectionStatus(isUserLoggedIn,decryptedData);
      } catch (error) {
        console.error('Failed to parse decrypted data:', error);
      }
      }
    });
  }

  checkRedirectionStatus(is_logged_in: boolean, decryptedData: any) {
    const logged_user_data =
      this.statePersistService.getLocalStorage('currentUser');

    if (is_logged_in && this.route.queryParams['_value']._branch_match_id) {
      try {
        this.statePersistService.setLocalStorage(
          'redirected_user_data',
          JSON.stringify(decryptedData)
        );

        if (logged_user_data?.id != decryptedData.logged_in) {
          this.is_redirected_user = true;
        } else {
          this.router.navigate(['home'], {
            queryParams: {
              store_id: decryptedData.store_id,
              retailer_id: decryptedData.retailer_id,
            },
          });
        }
      } catch (error) {
        this.router.navigate(['/not-found']);
      }
    } else if (
      is_logged_in &&
      !this.route.queryParams['_value']._branch_match_id
    ) {
      this.router.navigate(['home']);
    } else if (
      !is_logged_in &&
      this.route.queryParams['_value']._branch_match_id
    ) {
      try {
        if (Object.keys(decryptedData).length !== 0) {
          this.statePersistService.setLocalStorage(
            'redirected_user_data',
            JSON.stringify(decryptedData)
          );
        }
      } catch (error) {
        this.router.navigate(['/not-found']);
      }
    }
  }

  ngOnInit(): void {
    this.titleService.setTitle(UserModuleConsts.SIGNIN_PAGE_TITLE);
    this.loginForm = this.formBuilder.group({
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          this.customValidator.emailValidator,
        ],
      ],
      password: ['', [Validators.required]],
    });
    const has_user_token = this.checkIfUserToken();
    if (!has_user_token) {
      this.getAuthToken();
    }
    // this.getAuthToken()

    this.loginForm.get('email').valueChanges.subscribe((email) => {
      if (email) {
        this.errMessage = '';
      }
    });
    this.loginForm.get('password').valueChanges.subscribe((password) => {
      if (password) {
        this.errMessage = '';
      }
    });
  }

  getConfig(): void {
    this.store.dispatch(loadConfigData());
  }

  getAuthToken() {
    this.loginAuthService.authToken().subscribe(
      (data) => {
        // this.statePersistService.setLocalStorage('user_access_token', data['access_token'])
        let tokenDate = new Date();
        tokenDate.setSeconds(tokenDate.getSeconds() + data?.expires_in); //adding the expiry time in current time.
        tokenDate = new Date(tokenDate.setDate(tokenDate.getDate() - 2)); //subtracting the 2 day from token date
        data.expires_in = tokenDate;
        this.statePersistService.setLocalStorage(
          'user_access_token',
          JSON.stringify(data)
        );
      },
      (error) => {}
    );
  }

  checkIfUserToken() {
    const user_token =
      this.statePersistService.getLocalStorage('user_access_token');
    if (user_token) {
      return true;
    } else {
      return false;
    }
  }

  login() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }

    let store_data = this.statePersistService.getLocalStorage(
      'redirected_user_data'
    );
    if (store_data) {
      store_data = JSON.parse(store_data);
    }

    const encrypted_password = this.loginAuthService.createHashedPassword(
      this.loginForm.controls['password'].value
    );

    const payload = { ...this.loginForm.value, password: encrypted_password };
    this.recaptchaV3Service.execute('importantAction').subscribe(() => {
      this.loginAuthService.signInV2(payload).subscribe((data) => {
        if (data.status === 111) {
          this.googleAnalyticsService.eventEmitter(
            SharedConsts.SIGNIN_FAILS_EVENT,
            SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
            SharedConsts.SIGNIN_FAILS_EVENT_ACTION,
            SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
            SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
          );
          if (typeof data.message === 'string') {
            this.errMessage = data.message;
          } else {
            this.errMessage = data.message.non_field_errors;
          }
        } else if (data.status == 401) {
          this.googleAnalyticsService.eventEmitter(
            SharedConsts.SIGNIN_FAILS_EVENT,
            SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
            SharedConsts.SIGNIN_FAILS_EVENT_ACTION,
            SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
            SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
          );
          alert(data.message);
        } else {
          this.googleAnalyticsService.eventEmitter(
            SharedConsts.SIGNIN_EVENT,
            SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
            SharedConsts.SIGNIN_EVENT_ACTION,
            SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
            SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
          );
          this.authService.login(data.response);
          this.getConfig();
          if (data.response.is_temporary_password) {
            this.router.navigate(['/profile/reset-password']);
            return;
          } else {
            if (store_data && Object.keys(store_data).length !== 0) {
              if (store_data.logged_in == data.response.id) {
                this.router.navigate(['home'], {
                  queryParams: {
                    store_id: store_data.store_id,
                    retailer_id: store_data.retailer_obj,
                  },
                });

                return;
              } else {
                this.is_redirected_user = true;
                this.heading_message =
                  ' You are logging in as a different user';
                this.paragraph_message =
                  'Are you sure that you want to proceed with these credentials?';
                this.is_signed_differen_user = true;
              }
            } else {
              this.router.navigate(['/home']);
            }
          }
        }
      });
    });
  }

  cancelHandler() {
    if (!this.is_signed_differen_user) {
      this.has_cancelled = true;
      this.heading_message = 'Create Your Order';
      this.paragraph_message =
        'Please go to the Business Development Portal and select the store to create the order & login with the same Credentials on the web.';
    } else {
      this.is_redirected_user = false;
      this.router.navigate([], {
        queryParams: {
          id: null,
        },
        queryParamsHandling: 'merge',
      });
    }
  }

  onOkayHandler() {
    this.is_redirected_user = false;
    this.router.navigate([], {
      queryParams: {
        secret: null,
      },
      queryParamsHandling: 'merge',
    });
  }

  checkIfLoggedIn() {
    const user_data = JSON.parse(localStorage.getItem('currentUser'));
    if (user_data) {
      return true;
    } else {
      return false;
    }
  }

  logoutHandler() {
    if (!this.is_signed_differen_user) {
      this.loginAuthService.signOut().subscribe(
        (response) => {
          localStorage.removeItem('currentUser');
          sessionStorage.clear();
          this._compiler.clearCache();
          this.is_redirected_user = false;
        },
        (error) => {}
      );
    } else {
      this.router.navigate(['/home']);
      localStorage.removeItem('redirected_user_data');
    }
  }
}
